import { default as consoleEvents } from "@pb/utils/consoleEvents";
export function filterHiddenSustainabilityMarkers(markers, sustainabilityMarkerIds) {
    if (!sustainabilityMarkerIds) {
        return markers;
    }
    try {
        const sustainabilityMarkersToRemove = new Set(sustainabilityMarkerIds.map((s) => s.trim().toLowerCase()));
        const filterHiddenSustainabilityMarker = (marker) => marker
            .split(',')
            .filter((m) => !sustainabilityMarkersToRemove.has(m.trim().toLowerCase()))
            .join(',');
        return markers
            .reduce((acc, cur) => {
            if (cur.text) {
                const text = filterHiddenSustainabilityMarker(cur.text);
                if (text.length) {
                    return acc.concat(Object.assign(Object.assign({}, cur), { text }));
                }
            }
            return acc;
        }, [])
            .filter((val, idx, arr) => arr.indexOf(val) === idx);
    }
    catch (e) {
        consoleEvents.error('filterHiddenSustainabilityMarker failed', e);
        return markers;
    }
}
//# sourceMappingURL=filterHiddenSustainabilityMarkers.js.map